import { ClientType } from './client';

export enum QuoteStatus {
  Invalid = '0',
  CanQuote = '1',
  Quoted = '2',
  Incomplete = '3',
  Failed = '4',
}

export enum QuoteType {
  keyperson = 1,
  suretyship = 2,
  buyAndSellTraditional = 3,
  buyAndSellAlternative = 4,
  buyAndSellShareBuyBack = 5,
}

export interface QuoteItem {
  id: number;
  agentID: number;
  fnaid: number;
  fnaPartyID: number;
  quoteID: number;
  policyholder: string;
  lifeinsured: string;
  deathBenefit: number;
  typeID: QuoteType;
  roleplayerID: number;
  partyRoleplayerID: number;
  partyRoleplayerTypeID: ClientType;
  roleplayerTypeID: ClientType;
  roleplayerTypeNote: string;
  roleplayerTaxStatusID: number;
  roleplayerTaxStatusNote: string;
  roleplayerName: string;
  roleplayerIDReg: string;
  roleplayerDOBEst: string;
  brokerCode: string;
  practiceCode: string;
  quotePremium: number;
  quoteDiscountedPremium: number;
  quotePolicyFee: number;
  quoteTypeID: number;
  quoteStateID: number;
  quoteTypeName?: string;
  quoteTypeNote?: string;
  quoteStateName?: string;
  quoteStateNote?: string;
  typeName: string;
  typeNote: string;
  statusName: string;
  statusNote: string;
  statusID: QuoteStatus;
  quotePdfUrl?: string;
  partyRoleplayerName: string;
}
